// Nomes de produto num lugar só: os finais ainda estão em aberto (Q17), então trocar um nome custa uma linha aqui.
export const LABELS = {
  izze: 'Izze',
  turbo: 'Modo Turbo',
  developer: 'Modo Desenvolvedor',
  community: 'Community',        // escopo da rede compartilhada
  bands: { small: 'Small', medium: 'Medium', high: 'High' },   // faixas do Modo Turbo (composição provisória: Q7)
} as const;
